import React, { useEffect, useState } from 'react';

/**
 * @typedef {object} ImageWithFallbackProps
 * @property {string} [src] - The primary image source URL
 * @property {string} [srcOnError] - The fallback image source URL to use if primary fails
 */

/**
 * Image component that supports fallback to an alternate source on error
 * @param {ImageWithFallbackProps & React.ImgHTMLAttributes<HTMLImageElement>} props
 * @returns {React.JSX.Element}
 */
export const ImageWithFallback = ({ src = '', srcOnError = '', ...rest }) => {
  const [srcImg, setSrcImg] = useState(null);

  useEffect(() => {
    setSrcImg(null);
  }, [src]);

  const onError = () => {
    setSrcImg(srcOnError);
  };

  if (!srcOnError) {
    // oxlint-disable-next-line jsx-a11y/alt-text
    return <img src={src} {...rest} />;
  }

  if (srcImg) {
    // oxlint-disable-next-line jsx-a11y/alt-text
    return <img src={srcImg} {...rest} />;
  }

  // oxlint-disable-next-line jsx-a11y/alt-text
  return <img onError={onError} src={src} {...rest} />;
};
